// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';
const defaultState = {
  detail: {},
  history: [],
  historyOffset: 0,
  historyLimit: 25,
  loading: false,
  loadingHistory: false,
  error: null,
  historyFilters: {
    outcome: null,
    algo: null,
    date: { start: null, end: null },
    timeFrame: null,
    orderingPhy: null
  }
};

export default function patientReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.patient.ACTION_TYPES.RESET_FILTERS:
      return {
        ...state,
        historyFilters: {
          outcome: null,
          algo: null,
          date: { start: null, end: null },
          timeFrame: null,
          orderingPhy: null
        },
        historyOffset: 0
      };
    case actions.patient.ACTION_TYPES.SET_FILTERS:
      return {
        ...state,
        historyFilters: action.payload,
        historyOffset: 0
      };
    case actions.patient.ACTION_TYPES.SET_DETAIL:
      return { ...state, detail: action.payload, loading: false };
    case actions.patient.ACTION_TYPES.SET_HISTORY:
      let newHistory = [];
      if (state.historyOffset === 0) {
        newHistory = [...action.payload];
      } else {
        newHistory = [...state.history, ...action.payload];
      }
      return {
        ...state,
        history: newHistory,
        loadingHistory: false,
        historyOffset: action.payload.length + state.historyOffset
      };
    case actions.patient.ACTION_TYPES.RESET_OFFSET:
      return { ...state, offset: 0 };
    case actions.patient.ACTION_TYPES.RESET_HISTORY_OFFSET:
      return { ...state, historyOffset: 0, history: [] };
    case actions.patient.ACTION_TYPES.RESET_PATIENT:
      return defaultState;
    case actions.patient.ACTION_TYPES.ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loadingHistory: false
      };
    case actions.patient.ACTION_TYPES.LOADING:
      return { ...state, loading: true, error: null };
    case actions.patient.ACTION_TYPES.LOADING_HISTORY:
      return { ...state, loadingHistory: true, error: null };
    default:
      return state;
  }
}
